export default __webpack_public_path__ + "static/media/gele.8c9cbae5.png";